document.addEventListener("DOMContentLoaded", () => {
  const targets = document.querySelectorAll(".js-text-animation");

  if (targets.length === 0) return; // 対象要素がなければ終了

  targets.forEach((target) => {
    // 要素を複製
    const clonedElement = target.cloneNode(true);

    // 複製した要素から js-text-animation クラスを削除
    clonedElement.classList.remove("js-text-animation");

    // 複製要素を薄いテキストとしてスタイル設定
    clonedElement.classList.add("js-text-animation-bg");

    // 複製要素に aria-hidden="true" を追加
    clonedElement.setAttribute("aria-hidden", "true");

    // 複製要素を元の要素の親に追加
    target.style.position = "relative"; // 元要素を相対配置
    target.parentNode.insertBefore(clonedElement, target);

    // スマホかどうかを判定
    const isMobile = window.innerWidth <= 768; // スマホの基準を幅768px以下と定義

    // 要素の幅や高さに応じてアニメーション時間を計算
    // 要素の幅や高さに応じてアニメーション時間を計算
    const elementWidth = target.offsetWidth; // 要素の幅を取得
    const baseDuration = isMobile ? 1.5 : 1.2; // 基本の秒数（スマホ:PC）
    const duration = isMobile
      ? Math.min(baseDuration + elementWidth / 500, 3) // スマホ
      : Math.min(baseDuration + elementWidth / 800, 5); // PC

    // アニメーション用のスタイルを動的に追加
    target.style.animationDuration = `${duration}s`;
    clonedElement.style.animationDuration = `${duration}s`;

    // アニメーションの準備
    target.style.zIndex = "2";
  });
});
